import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ClaimsSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing(10)} ${spacing(20)};
  background: ${({ theme }) => theme.colors.secondaryColor2};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  color: ${({ theme }) => theme.newUI.defaultColors.text};

  & > * {
    width: 100%;
  }
  @media ${media.maxWidth.sm} {
    padding: ${spacing(10)} ${spacing(5)};
  }
`;

export const $Heading = styled.div`
  font-weight: 700;
  ${fontStyle('base')};
  text-align: center;
  color: ${({ theme }) => theme.newUI.defaultColors.heading};
  margin-bottom: ${spacing('xl')};
`;
export const $Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const $Spacing = styled.div`
  margin-bottom: ${spacing('xl')};
`;

export const $CustomerCommentRow = styled(Row)`
  margin-top: ${spacing(1.5)};
  font-weight: ${fontWeight('bold')};
  align-items: center;
  width: 100%;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const $IconPosition = styled.div`
  margin-right: ${spacing(2.5)};
  display: flex;
`;

export const $CardContentContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
`;
